import type { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http'
import { inject } from '@angular/core'
import type { Observable } from 'rxjs'

import { isUrlInternal } from '@app/core/http/is-url-internal'
import { TrackingPropsService } from '@app/modules/tracking/services/tracking-props.service'

const PROPS_HEADER_NAME = 'frontend-props'

export function trackingHeadersInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const trackingPropsService = inject(TrackingPropsService)

  if (!isUrlInternal(request.url)) {
    return next(request)
  }

  const headers = request.headers.append(PROPS_HEADER_NAME, JSON.stringify(trackingPropsService.get()))
  return next(request.clone({ headers }))
}
